export default __webpack_public_path__ + "static/media/property_407.35422b44.png";